export const transformCollectionPolicy = dto => ({
  canActivate: dto.can_activate,
  planActivated: dto.plan_activated,
  maxItemCount: dto.max_item_count
});